import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
// 引入ElementUI
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
// 引入axios
import axios from 'axios'
// 引入NProgress
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'

import './utils/permission'
import "@/assets/icons";

import SvgIcon from "@/components/SvgIcon";
import DictTag from "@/components/DictTag";

// 全局注册
Vue.use(ElementUI)
Vue.prototype.$axios = axios
Vue.prototype.$NProgress = NProgress

Vue.config.productionTip = false

Vue.component("SvgIcon", SvgIcon);
Vue.component("DictTag", DictTag);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')